import * as Yup from "yup";

export const clientGroupSchema = Yup.object().shape({
  name: Yup.string().required("Nome é obrigatório"),
});
